// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pricing-plans[data-v-5a1b31da]{background:#1C0C32}.switchToRssSection[data-v-5a1b31da]{margin-top:56px}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
